import { ILoadDateFilterProps } from '../components/load-filters/load-filter-advanced/ILoadFilterAdvanced';
import IFiltersModel from '../interfaces/IFiltersModel';
import ILoadsLocationResponse from '../interfaces/loads/ILoadsLocationResponse';
import ILoadMaterialResponse from '../interfaces/loads/ILoadMaterialResponse';
import { ISelectAutocompleteProps } from '../components/select-autocomplete/ISelectAutocomplete';
import ISelectInputModel from '../components/load-filters/load-filter-advanced/components/location-filter/interfaces/ISelectInputModel';
import { ILocationFilter } from '../components/load-filters/load-filter-advanced/components/location-filter/interfaces/ILocationFilter';

export function setDestinationLocationFilterProps(
    advancedFilter: Partial<IFiltersModel>,
    destinationUFOptions: ISelectInputModel[],
    setAdvancedFilters: (filtersModel: IFiltersModel) => void,
    destinationDescriptionOptions: ISelectInputModel[],
    handleDestinationDescriptionSearch: (
        value: string,
    ) => Promise<ILoadsLocationResponse[]>,
    handleDestinationDescriptionSearchResult: (
        data: ILoadsLocationResponse[],
    ) => void,
) {
    return () => {
        return {
            title: 'Destino',
            federativeUnitId:
                'load-destination-federative-unit-advanced-filter',
            federativeUnitLabel: 'Estados',
            federativeUnitValue: advancedFilter?.destinationFederativeUnit,
            federativeUnitOptions: destinationUFOptions,
            onFederativeUnitChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    destinationFederativeUnit: e,
                });
            },
            descriptionId: 'load-origin-destinations-advanced-filter',
            descriptionLabel: 'Destinos',
            descriptionValue: advancedFilter?.destinationLocations,
            descriptionOptions: destinationDescriptionOptions,
            onDescriptionChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    destinationLocations: e,
                });
            },
            onDescriptionSearch: handleDestinationDescriptionSearch,
            onDescriptionFetchDataResults:
                handleDestinationDescriptionSearchResult,
        } as ILocationFilter;
    };
}

export function setSourceLocationFilterProps(
    advancedFilter: Partial<IFiltersModel>,
    sourceUFOptions: ISelectInputModel[],
    setAdvancedFilters: (filtersModel: IFiltersModel) => void,
    sourceDescriptionOptions: ISelectInputModel[],
    handleSourceDescriptionSearch: (
        value: string,
    ) => Promise<ILoadsLocationResponse[]>,
    handleSourceDescriptionSearchResult: (
        data: ILoadsLocationResponse[],
    ) => void,
) {
    return () => {
        return {
            title: 'Origem',
            federativeUnitId: 'load-origin-federative-unit-advanced-filter',
            federativeUnitLabel: 'Estados',
            federativeUnitValue: advancedFilter?.originFederativeUnit,
            federativeUnitOptions: sourceUFOptions,
            onFederativeUnitChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    originFederativeUnit: e,
                });
            },
            descriptionLabel: 'Origens',
            descriptionId: 'load-origin-sources-advanced-filter',
            descriptionValue: advancedFilter?.originLocations,
            descriptionOptions: sourceDescriptionOptions,
            onDescriptionChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    originLocations: e,
                });
            },
            onDescriptionSearch: handleSourceDescriptionSearch,
            onDescriptionFetchDataResults: handleSourceDescriptionSearchResult,
        } as ILocationFilter;
    };
}

export function setMaterialFilterProps(
    advancedFilter: Partial<IFiltersModel>,
    setAdvancedFilters: (filtersModel: IFiltersModel) => void,
    handleMaterialSearch: (value: string) => Promise<ILoadMaterialResponse[]>,
    handleMaterialSearchResult: (data: ILoadMaterialResponse[]) => void,
    materialOptions: ISelectInputModel[],
) {
    return () => {
        return {
            id: 'load-product-advanced-filter',
            label: 'Produto',
            value: advancedFilter?.product,
            onChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    product: e,
                });
            },
            onSearch: handleMaterialSearch,
            onFetchDataResults: handleMaterialSearchResult,
            options: materialOptions,
            placeholder: 'DigitePesquisar',
        } as ISelectAutocompleteProps;
    };
}

export function setChannelFilterProps(
    advancedFilter: Partial<IFiltersModel>,
    setAdvancedFilters: (filtersModel: IFiltersModel) => void,
    getLoadChannelOptions: () => any[],
) {
    return () => {
        return {
            id: 'load-channel-advanced-filter',
            label: 'Canal',
            value: advancedFilter?.channels,
            onChange: (e: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    channels: e,
                });
            },
            options: getLoadChannelOptions(),
            placeholder: 'DigitePesquisar',
        } as ISelectAutocompleteProps;
    };
}

export function setDateFilterProps(
    advancedFilter: Partial<IFiltersModel>,
    setAdvancedFilters: (filtersModel: IFiltersModel) => void,
    minDate?: Date,
    daysRangeLimit?: number,
) {
    return () => {
        return {
            id: 'date-range-picker-advanced-filter',
            startDateLabel: 'CarregamentoInicio',
            startDate: advancedFilter?.initialCollectionDate,
            onStartDateChange: (value: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    initialCollectionDate: value,
                });
            },
            endDateLabel: 'CarregamentoFim',
            endDate: advancedFilter?.endingCollectionDate,
            onEndDateChange: (value: any) => {
                setAdvancedFilters({
                    ...advancedFilter,
                    endingCollectionDate: value,
                });
            },
            ...(minDate && { minDate }),
            ...(daysRangeLimit !== undefined && { daysRangeLimit }),
        } as ILoadDateFilterProps;
    };
}
